(function(){
  var lockedHTML = {
    blanket: '<div class="th-lock-icon">🔒</div><div class="th-lock-text">Locked</div>',
    shipping: '<div class="th-lock-icon">🔒</div><div class="th-lock-text">Locked</div>'
  };
  var unlockedHTML = {};

  document.querySelectorAll('.th-gift-card[data-gift="blanket"],.th-gift-card[data-gift="shipping"]').forEach(function(card){
    unlockedHTML[card.dataset.gift] = card.innerHTML;
  });

  function isBundle(){
    var singlePack = document.querySelector('quantity-breaks input[type="radio"][value="1"]');
    return !(singlePack && singlePack.checked);
  }

  function updateGiftDisplay(){
    ['blanket','shipping'].forEach(function(giftType){
      var card = document.querySelector('.th-gift-card[data-gift="'+giftType+'"]');
      if(!card) return;

      if(isBundle()){
        card.innerHTML = unlockedHTML[giftType] || card.innerHTML;
        card.classList.remove('th-locked');
      } else {
        card.innerHTML = lockedHTML[giftType];
        card.classList.add('th-locked');
      }
    });
  }

  setTimeout(updateGiftDisplay, 300);
  setTimeout(updateGiftDisplay, 800);
  document.addEventListener('change', updateGiftDisplay);
  document.addEventListener('click', function(){
    setTimeout(updateGiftDisplay, 200);
  });
})();
